module.exports = __webpack_public_path__ + "static/media/mm.f06bd610.svg";